var map = {
	"./en/menu.json": [
		3943,
		943
	],
	"./en/page.json": [
		7938,
		938
	],
	"./fr/menu.json": [
		1388,
		388
	],
	"./fr/page.json": [
		9627,
		627
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8140;
module.exports = webpackAsyncContext;